import React, { useState, useEffect } from 'react'
import { capitalizeFirstCharacter, checkDateDiff, getAbbreviatedState, getEmailAndPhoneFromContacts, getGlobalAcceptanceValue } from '../../../services/helper'
import { Modal } from 'rsuite'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { BiError } from 'react-icons/bi'
import { useDispatch, useStore } from 'react-redux'
import { approveOrRejectListSupplier, addRejectedListSupplierColumns, getSuppliersDataByIds, getMasterSuppliersByIds, approveSuppliers, rejectSuppliers, getAllContactsByIds } from '../../../redux/actions/vendor';
import { toast } from '../../CommonComponents/ToastComponent/toast';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { RiFileCopyLine } from 'react-icons/ri'
import { removeListSupplierFromCall } from '../../../redux/actions/caller'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { approvePartnerSubmission, rejectPartnerSubmission } from '../../../redux/actions/partnerSubmissions'
import { FaExternalLinkAlt } from 'react-icons/fa'

const QAList = ({ show, onGoBack, allVendors, page, checkedKeys = [], resetCheckedTableData = () => { } }) => {
    const columns = [
        { name: 'suppliername', label: 'Supplier name' },
        { name: 'address1', label: 'Address' },
        { name: 'city', label: 'City' },
        { name: 'state', label: 'State' },
        { name: 'zip', label: 'Zip' },
        { name: 'email', label: 'Email' },
        { name: 'phone', label: 'Phone' },
    ]

    const vendorCols = ['imported', 'matched']
    const dispatch = useDispatch()
    const store = useStore().getState()

    const [allMatchedVendors, setAllMatchedVendors] = useState([])
    const [currentSupplier, setCurrentSupplier] = useState({})
    const [matchedSupplier, setMatchedSupplier] = useState({})
    const [unmatchedColumns, setUnmatchedColumns] = useState([])
    const [rejectedListSupplierColumns, setRejectedListSupplierColumns] = useState({})
    const [qaStatus, setQaStatus] = useState('')
    const [isApprovingOrRejecting, setIsApprovingOrRejecting] = useState(false)
    const [isRefreshListsData, setIsRefreshListsData] = useState(false)

    const handleRejectClick = () => {
        setQaStatus('Rejected')
    }

    const handleApproveClick = async (type) => {
        let matchedSup = {};
        setIsApprovingOrRejecting(true)
        dispatch(approveOrRejectListSupplier(currentSupplier?.id, type)).then(async () => {
            const currentIndex = allMatchedVendors.indexOf(currentSupplier);
            const nextIndex = (currentIndex + 1) % allMatchedVendors.length;
            allMatchedVendors[currentIndex]['qaStatus'] = qaStatus.toLowerCase() === 'rejected' ? qaStatus : 'Approved'

            await dispatch(getSuppliersDataByIds([allMatchedVendors?.[nextIndex]?.matchedSupplierId], [], true)).then((masterSup) => {
                matchedSup = masterSup?.[0] || {}
            }).catch(err => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get Supplier Data'
                })
            })

            setIsApprovingOrRejecting(false)
            setQaStatus('Pending')
            setRejectedListSupplierColumns({})
            if (type === 'reject' && Object.keys(rejectedListSupplierColumns).length > 0) {
                await dispatch(addRejectedListSupplierColumns(rejectedListSupplierColumns, currentSupplier?.id)).then(() => {
                    toast.show({
                        title: 'Success',
                        description: `Successfully added rejected list supplier columns data!`
                    })
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: `Failed to add rejected list supplier columns data!`
                    })
                })
            }

            // remove from calls if is in calls
            if (type === 'approve' && currentSupplier?.isInCalls && currentSupplier?.matchedSupplierId) {
                const masterId = matchedSupplier?.isMaster ? matchedSupplier?.id : matchedSupplier?.masterId
                const getMasterSupplierData = async (masterId) => {
                    const data = await dispatch(getMasterSuppliersByIds({ primaryMasterId: false, masterIds: masterId })).then(res => {
                        return res
                    })
                    return data
                }
                const masterData = await getMasterSupplierData([masterId])
                const acceptanceDate = masterData?.[0]?.acceptanceDate
                if (acceptanceDate) {
                    const dateDiff = checkDateDiff(new Date(acceptanceDate), 18)
                    if (!dateDiff && (masterData?.[0]?.isAcceptAmericanExpress !== null || masterData?.[0]?.isAcceptMasterCard !== null || masterData?.[0]?.isAcceptVisa !== null)) {
                        await dispatch(removeListSupplierFromCall(currentSupplier?.id)).then(() => {
                        }).catch(() => {
                            toast.show({
                                title: 'Warning',
                                description: `Failed to remove list supplier from calls!`
                            })
                        })
                    }
                }
            }

            const acceptanceType = await getGlobalAcceptanceValue(matchedSup, matchedSup?.masterSupplierId, dispatch)
            matchedSup.acceptanceType = acceptanceType || 'Unknown'

            const contacts = await getEmailAndPhoneFromContacts(allMatchedVendors[nextIndex], matchedSup, dispatch)
            allMatchedVendors[nextIndex].email = allMatchedVendors[nextIndex]?.email ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.email))?.email : ''
            allMatchedVendors[nextIndex].phone = allMatchedVendors[nextIndex]?.phone ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.phone))?.phone : ''
            matchedSup.email = matchedSup?.email ? contacts?.find(data => data?.id === parseInt(matchedSup?.email))?.email : ''
            matchedSup.phone = matchedSup?.phone ? contacts?.find(data => data?.id === parseInt(matchedSup?.phone))?.phone : ''

            setIsRefreshListsData(true)
            setMatchedSupplier(matchedSup)
            setCurrentSupplier(allMatchedVendors[nextIndex])
            if (nextIndex < currentIndex || nextIndex === 0 || allMatchedVendors.length === 1) {
                onGoBack(!isRefreshListsData ? true : isRefreshListsData)
            }
            toast.show({
                title: 'Success',
                description: `Successfully ${type === 'reject' ? 'rejected' : 'approved'} list supplier!`
            })
        }).catch(() => {
            setIsApprovingOrRejecting(false)
            toast.show({
                title: 'Warning',
                description: `Failed to ${type} list supplier!`
            })
        })
    }

    useEffect(async () => {
        let matchedSup = {}
        if (allVendors.length) {
            setIsApprovingOrRejecting(true)
            let status = page === 'list' ? (allVendors?.[0]?.['approvedByManager'] === true ? 'Approved' : allVendors?.[0]?.['approvedByManager'] === false ? 'Rejected' : 'Pending') : page === 'partnerSubmission' ? allVendors?.[0]?.currentStatus : 'DBM QA Pending'

            if (allVendors?.[0]?.matchedSupplierId) {
                await dispatch(getSuppliersDataByIds([allVendors?.[0]?.matchedSupplierId], [], true)).then((res) => {
                    matchedSup = res?.[0] || {}
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed to get Supplier Data'
                    })
                })
            }

            if (allVendors[0]?.zip) {
                let updatedZip = allVendors[0].zip.includes("-") ? allVendors[0].zip.split("-")[0] : allVendors[0].zip;
                allVendors[0] = {
                    ...allVendors[0],
                    zip: updatedZip
                }
            }
            if (matchedSup?.zip) {
                let updatedZip = matchedSup.zip.includes("-") ? matchedSup.zip.split("-")[0] : matchedSup.zip;
                matchedSup = {
                    ...matchedSup,
                    zip: updatedZip
                }
            }

            if (page === 'list' || page === 'partnerSubmission') {
                const acceptanceType = await getGlobalAcceptanceValue(matchedSup, matchedSup?.masterSupplierId, dispatch)
                matchedSup.acceptanceType = acceptanceType || 'Unknown'
            }


            const contacts = await getEmailAndPhoneFromContacts(allVendors?.[0], matchedSup, dispatch)
            if (page !== 'partnerSubmission') {
                allVendors[0].email = allVendors?.[0]?.email ? contacts?.find(data => data?.id === parseInt(allVendors?.[0]?.email))?.email : ''
                allVendors[0].phone = allVendors?.[0]?.phone ? contacts?.find(data => data?.id === parseInt(allVendors?.[0]?.phone))?.phone : ''
            }
            matchedSup.email = matchedSup?.email ? contacts?.find(data => data?.id === parseInt(matchedSup?.email))?.email : ''
            matchedSup.phone = matchedSup?.phone ? contacts?.find(data => data?.id === parseInt(matchedSup?.phone))?.phone : ''

            setCurrentSupplier(allVendors?.[0])
            setMatchedSupplier(matchedSup)
            setQaStatus(status)
            setAllMatchedVendors(allVendors)
            setIsApprovingOrRejecting(false)
        } else {
            setCurrentSupplier({})
            setMatchedSupplier({})
            setQaStatus('Pending')
            setAllMatchedVendors([])
        }
    }, [])

    useEffect(() => {
        if (((matchedSupplier && !Object.keys(matchedSupplier).length) || !matchedSupplier) || ((currentSupplier && !Object.keys(currentSupplier).length) || !currentSupplier)) {
            return
        }
        let unmatchedColumns = []
        columns.map((col) => {
            let currentSupColValue = (currentSupplier?.[col.name] && typeof currentSupplier?.[col.name] === 'string') ? currentSupplier?.[col.name].toLowerCase() : currentSupplier?.[col.name]
            let matchedSupColValue = (matchedSupplier?.[col.name] && typeof matchedSupplier?.[col.name] === 'string') ? matchedSupplier?.[col.name].toLowerCase() : matchedSupplier?.[col.name]

            if (col.name === 'phone') {
                currentSupColValue = currentSupColValue ? currentSupColValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '') : currentSupColValue
                matchedSupColValue = matchedSupColValue ? matchedSupColValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '') : matchedSupColValue
            }
            if (col.name === 'zip') {
                if (currentSupColValue === null || currentSupColValue === undefined) {
                    currentSupColValue = null
                } else {
                    currentSupColValue = currentSupColValue.split("-")[0];
                }

                if (matchedSupColValue === null || matchedSupColValue === undefined) {
                    matchedSupColValue = null;
                } else {
                    matchedSupColValue = matchedSupColValue.split('-')[0];
                }
            }

            if ((currentSupColValue || matchedSupColValue) && currentSupColValue !== matchedSupColValue) {
                unmatchedColumns.push(col.name)
            }
        })

        setUnmatchedColumns(unmatchedColumns)
    }, [matchedSupplier, currentSupplier])

    const handleInputSelect = (event, colName) => {
        if (event.target.checked) {
            setRejectedListSupplierColumns({
                ...rejectedListSupplierColumns,
                [colName]: event.target.labels[0].innerText
            })
        } else {
            let tmpRejectedListSupplierCols = { ...rejectedListSupplierColumns }
            delete tmpRejectedListSupplierCols?.[colName];
            setRejectedListSupplierColumns(tmpRejectedListSupplierCols)
        }
    }

    const handleGoBackClick = () => {
        if (qaStatus.toLowerCase() === 'rejected') {
            setRejectedListSupplierColumns({})
            setQaStatus('Pending')
        } else {
            onGoBack(isRefreshListsData)
        }
    }

    const onSkip = async () => {
        setIsApprovingOrRejecting(true)
        const currentIndex = allMatchedVendors.indexOf(currentSupplier);
        const nextIndex = (currentIndex + 1) % allMatchedVendors.length;

        let matchedSup = {}
        let contacts = []

        if (allMatchedVendors[nextIndex]?.zip) {
            let updatedZip = allMatchedVendors[nextIndex].zip.includes("-") ? allMatchedVendors[nextIndex].zip.split("-")[0] : allMatchedVendors[nextIndex].zip;
            allMatchedVendors[nextIndex] = {
                ...allMatchedVendors[nextIndex],
                zip: updatedZip
            }
        }

        if (checkedKeys?.length > 0) {
            resetCheckedTableData(currentSupplier?.id)
        }

        if (allMatchedVendors?.[nextIndex]?.matchedSupplierId) {
            await dispatch(getSuppliersDataByIds([allMatchedVendors?.[nextIndex]?.matchedSupplierId], [], true)).then((masterSup) => {
                matchedSup = masterSup?.[0] || {}
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get Supplier Data'
                })
            })
        }

        if (matchedSup?.zip) {
            let updatedZip = matchedSup.zip.includes("-") ? matchedSup.zip.split("-")[0] : matchedSup.zip;
            matchedSup = {
                ...matchedSup,
                zip: updatedZip
            }
        }

        if (page === 'list' || page === 'partnerSubmission') {
            const acceptanceType = await getGlobalAcceptanceValue(matchedSup, matchedSup?.masterSupplierId, dispatch)
            matchedSup.acceptanceType = acceptanceType || 'Unknown'
        }

        contacts = await getEmailAndPhoneFromContacts(allMatchedVendors[nextIndex], matchedSup, dispatch)
        if (page !== 'partnerSubmission') {
            allMatchedVendors[nextIndex].email = allMatchedVendors[nextIndex]?.email ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.email))?.email : ''
            allMatchedVendors[nextIndex].phone = allMatchedVendors[nextIndex]?.phone ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.phone))?.phone : ''
        }
        matchedSup.email = matchedSup?.email ? contacts?.find(data => data?.id === parseInt(matchedSup?.email))?.email : ''
        matchedSup.phone = matchedSup?.phone ? contacts?.find(data => data?.id === parseInt(matchedSup?.phone))?.phone : ''

        setMatchedSupplier(matchedSup)
        setCurrentSupplier(allMatchedVendors[nextIndex])
        setIsApprovingOrRejecting(false)
        let status = page === 'list' ? (allMatchedVendors?.[nextIndex]?.['approvedByManager'] === true ? 'Approved' : allMatchedVendors?.[nextIndex]?.['approvedByManager'] === false ? 'Rejected' : 'Pending') : page === 'partnerSubmission' ? allMatchedVendors?.[nextIndex]?.currentStatus : 'DBM QA Pending'
        setQaStatus(status)
        if (nextIndex < currentIndex || nextIndex === 0 || allMatchedVendors.length === 1) {
            onGoBack(isRefreshListsData)
        }
    }

    let bgColorClass = qaStatus.toLowerCase() === 'approved' ? 'bg-green' : qaStatus.toLowerCase() === 'rejected' ? 'bg-red' : 'bg-yellow'

    const approveOrRejectChildOrphans = async (id, type) => {
        let matchedSup = {};
        let ids = []
        if (id) {
            ids.push(id)
        }
        const currentIndex = allMatchedVendors.indexOf(currentSupplier);
        const nextIndex = (currentIndex + 1) % allMatchedVendors.length;

        if (type === 'approve') {
            await dispatch(approveSuppliers({ ids })).then(async (res) => {
                toast.show({
                    title: 'Success',
                    description: 'Successfully Approved Suppliers',
                })
                await dispatch(getSuppliersDataByIds([allMatchedVendors?.[nextIndex]?.matchedSupplierId])).then((masterSup) => {
                    matchedSup = masterSup?.[0] || {}
                }).catch(err => {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Get The Supplier Details'
                    })
                })

                if (checkedKeys?.length > 0) {
                    resetCheckedTableData(id)
                }
            }).catch(() => {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Approve Supplier',
                })

            })
        } else {
            await dispatch(rejectSuppliers({ ids })).then(async (res) => {
                toast.show({
                    title: 'Success',
                    description: 'Successfully Reject Suppliers',
                })
                await dispatch(getSuppliersDataByIds([allMatchedVendors?.[nextIndex]?.matchedSupplierId])).then((masterSup) => {
                    matchedSup = masterSup?.[0] || {}
                }).catch(() => {
                    return toast.show({
                        title: 'Danger',
                        description: 'Unable To Get The Supplier Details'
                    })
                })

                if (checkedKeys?.length > 0) {
                    resetCheckedTableData(id)
                }
            }).catch(err => {
                return toast.show({
                    title: 'Danger',
                    description: 'Unable To Reject Selected Supplier',
                })
            })
        }

        const contacts = await getEmailAndPhoneFromContacts(allMatchedVendors[nextIndex], matchedSup, dispatch)
        allMatchedVendors[nextIndex].email = allMatchedVendors[nextIndex]?.email ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.email))?.email : ''
        allMatchedVendors[nextIndex].phone = allMatchedVendors[nextIndex]?.phone ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.phone))?.phone : ''
        matchedSup.email = matchedSup?.email ? contacts?.find(data => data?.id === parseInt(matchedSup?.email))?.email : ''
        matchedSup.phone = matchedSup?.phone ? contacts?.find(data => data?.id === parseInt(matchedSup?.phone))?.phone : ''

        setIsRefreshListsData(true)
        setMatchedSupplier(matchedSup)
        setCurrentSupplier(allMatchedVendors[nextIndex])
        if (nextIndex < currentIndex || nextIndex === 0 || allMatchedVendors.length === 1) {
            onGoBack(!isRefreshListsData ? true : isRefreshListsData)
        }
    }

    const approvePartnerSubmissionRecord = async (id, type) => {
        setIsApprovingOrRejecting(true)
        let matchedSup = {}
        const currentIndex = allMatchedVendors.indexOf(currentSupplier);
        const nextIndex = (currentIndex + 1) % allMatchedVendors.length;

        if (type === 'approve') {
            await dispatch(approvePartnerSubmission({ submissionId: id })).then(async (res) => {
                if (allMatchedVendors?.[nextIndex]?.matchedSupplierId) {
                    await dispatch(getSuppliersDataByIds([allMatchedVendors?.[nextIndex]?.matchedSupplierId], [], true)).then((masterSup) => {
                        matchedSup = masterSup?.[0] || {}
                    }).catch(() => {
                        return toast.show({
                            title: 'Danger',
                            description: 'Unable To Get The Supplier Details'
                        })
                    })
                }

                if (checkedKeys?.length > 0) {
                    resetCheckedTableData(id)
                }
                toast.show({
                    title: 'Success',
                    description: res?.message ? res?.message : 'Partner submission record approved successfully!'
                })
                setIsApprovingOrRejecting(false)
            }).catch(err => {
                setIsApprovingOrRejecting(false)
                return toast.show({
                    title: 'Warning',
                    description: err?.response?.data?.message ? 'Server Error: ' + err?.response?.data?.message : 'Failed to approve!'
                })
            })
        } else {
            await dispatch(rejectPartnerSubmission({ submissionIds: [id] })).then(async (res) => {
                if (allMatchedVendors?.[nextIndex]?.matchedSupplierId) {
                    await dispatch(getSuppliersDataByIds([allMatchedVendors?.[nextIndex]?.matchedSupplierId], [], true)).then((masterSup) => {
                        matchedSup = masterSup?.[0] || {}
                    }).catch(() => {
                        return toast.show({
                            title: 'Danger',
                            description: 'Unable To Get The Supplier Details'
                        })
                    })
                }

                if (checkedKeys?.length > 0) {
                    resetCheckedTableData(id)
                }
                toast.show({
                    title: 'Success',
                    description: res?.message ? res?.message : 'Partner submission record rejected successfully!'
                })
                setIsApprovingOrRejecting(false)
            }).catch(err => {
                setIsApprovingOrRejecting(false)
                return toast.show({
                    title: 'Warning',
                    description: err?.response?.data?.message ? 'Server Error: ' + err?.response?.data?.message : 'Failed to reject partner submission!'
                })
            })
        }

        const contacts = await getEmailAndPhoneFromContacts(allMatchedVendors[nextIndex], matchedSup, dispatch)
        if (page !== 'partnerSubmission') {
            allMatchedVendors[nextIndex].email = allMatchedVendors[nextIndex]?.email ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.email))?.email : ''
            allMatchedVendors[nextIndex].phone = allMatchedVendors[nextIndex]?.phone ? contacts?.find(data => data?.id === parseInt(allMatchedVendors[nextIndex]?.phone))?.phone : ''
        }
        matchedSup.email = matchedSup?.email ? contacts?.find(data => data?.id === parseInt(matchedSup?.email))?.email : ''
        matchedSup.phone = matchedSup?.phone ? contacts?.find(data => data?.id === parseInt(matchedSup?.phone))?.phone : ''
    
        if (matchedSup?.masterSupplierId) {
            const acceptanceType = await getGlobalAcceptanceValue(matchedSup, matchedSup?.masterSupplierId, dispatch)
            matchedSup.acceptanceType = acceptanceType || 'Unknown'
        }

        setIsRefreshListsData(true)
        setMatchedSupplier(matchedSup)
        setCurrentSupplier(allMatchedVendors[nextIndex])
        if (nextIndex < currentIndex || nextIndex === 0 || allMatchedVendors.length === 1) {
            onGoBack(!isRefreshListsData ? true : isRefreshListsData)
        }
    }

    const onApproveClick = () => {
        if (page === "list") {
            handleApproveClick('approve')
        } else if (page === "autoMatchedChildren") {
            approveOrRejectChildOrphans(currentSupplier?.id, 'approve')
        } else if (page === "partnerSubmission") {
            approvePartnerSubmissionRecord(currentSupplier?.id, 'approve')
        }
    }

    const onRejectClick = async () => {
        if (page === "list") {
            handleRejectClick()
        } else if (page === "autoMatchedChildren") {
            approveOrRejectChildOrphans(currentSupplier?.id, 'reject')
        } else if (page === "partnerSubmission") {
            approvePartnerSubmissionRecord(currentSupplier?.id, 'reject')
        }
    }

    return (
        <div>
            <Modal
                backdrop='static'
                className="qa-list-modal px-5 mx-5"
                show={show}
                size={'xl'}
                onClick={() => { onGoBack(isRefreshListsData) }}
                onHide={() => { onGoBack(isRefreshListsData) }}
            >
                <Modal.Header>
                </Modal.Header>
                <Modal.Body className='me-5'>
                    <div className="header row">
                        <div className="col-6 d-flex align-items-center gap-3">
                            <div className="w-100 d-flex align-items-center gap-3">
                                <h4 className="w-50 mb-0 text-black fw-bold"> QA Status </h4>
                                <div className="w-100">
                                    <span className={`h5 rounded text-white p-4 pt-2 pb-2 mb-0 ${bgColorClass}`}> {qaStatus} </span>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end col-6">
                            {qaStatus.toLowerCase() === 'rejected' ? null : <button className=" bg-primary rounded text-white p-5 pt-3 pb-3 h4 mb-0 mx-3 btn-sm" onClick={onSkip}> Skip </button>}
                            <button className=" bg-gray rounded text-white p-5 pt-3 pb-3 h4 mb-0 " onClick={handleGoBackClick}> Go Back </button>
                        </div>
                    </div>
                    <div className="header row">
                        <div className="col-6 d-flex align-items-center gap-3">
                            <div className="w-100 d-flex align-items-center gap-3">
                                <h4 className="w-50 mb-0 text-black fw-bold"> Match Score </h4>
                                <div className="w-100">
                                    <h4 classNameName='text-black' style={{ margin: 0 }}> {(page === 'list' || page === 'partnerSubmission') ? currentSupplier?.matchScore ? parseFloat(currentSupplier?.matchScore).toFixed(3) : 0 : currentSupplier?.autoDbmMatchScore ? parseFloat(currentSupplier?.autoDbmMatchScore).toFixed(3) : 0} </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    {page === 'autoMatchedChildren' && <div className="header row mt-3">
                        <div className="col-6 d-flex align-items-center gap-3">
                            <div className="w-100 d-flex align-items-center gap-3">
                                <h4 className="w-50 mb-0 text-black fw-bold"> Acceptance Type </h4>
                                <div className="w-100">
                                    <h3 className='text-black fw-bold mb-0'> {currentSupplier?.acceptanceType} </h3>
                                </div>
                            </div>
                        </div>
                    </div>}
                    <div className={`content mt-4 position-relative ${isApprovingOrRejecting && 'loading'}`}>
                        {isApprovingOrRejecting && <LoaderComponent />}
                        <div className='d-flex gap-3'>
                            {vendorCols.map((column) => {
                                if (column === 'matched' && qaStatus?.toLowerCase() === 'unmatched - pending qa' && page === 'partnerSubmission') {
                                    return
                                }
                                return (
                                    <div className={`w-100`}>
                                        {
                                            page === 'list' || page === 'partnerSubmission' && <div> {column === 'imported' ?
                                                <h3 className='text-black fw-bold'> {page === 'list' ? 'Select Unmatched Fields' : 'Imported Data'} </h3>
                                                : <h3 className='text-black fw-bold d-flex align-items-center flex-wrap justify-content-between'>
                                                    <span>{page === 'list' ? 'Suppliers' + capitalizeFirstCharacter(column) : 'Matched Supplier'}
                                                        {!matchedSupplier?.id && (
                                                            <span className='text-red'> (No Matched Supplier found) </span>
                                                        )}
                                                    </span>
                                                    <span className='h4 mb-0 fw-bold me-2'>
                                                        <i>Acceptance Type: {matchedSupplier?.acceptanceType}</i>
                                                        {page === 'partnerSubmission' && (
                                                            <Link className='ms-2' to={`/suppliers/${matchedSupplier?.masterSupplierId}`} target="_blank">
                                                                <FaExternalLinkAlt />
                                                            </Link>
                                                        )}
                                                    </span>
                                                </h3>}
                                            </div>
                                        }
                                        {page === 'autoMatchedChildren' && <h3 className='text-black fw-bold'> {column === 'imported' ? 'Child Supplier' : 'Matched Supplier'} </h3>}

                                        <div className='border border-2 rounded p-3 d-flex flex-column gap-3'>
                                            {columns.map((col, index) => {
                                                if (col.name === 'state') {
                                                    if (column === 'matched' && matchedSupplier) {
                                                        if (!matchedSupplier?.hasOwnProperty('abbreviatedState') || matchedSupplier?.abbreviatedState === null) {
                                                            matchedSupplier[col.name] = getAbbreviatedState('', matchedSupplier?.[col.name])
                                                        } else {
                                                            matchedSupplier[col.name] = matchedSupplier?.abbreviatedState
                                                        }
                                                    }
                                                    if (column === 'imported' && currentSupplier && Object.keys(currentSupplier)?.length) {
                                                        if (currentSupplier?.[col.name]) {
                                                            currentSupplier[col.name] = getAbbreviatedState('', currentSupplier?.[col.name])
                                                        }
                                                    }
                                                }

                                                return (
                                                    <div className={`d-flex align-items-center gap-3`}>
                                                        <h4 className='w-50 mb-0 text-black'>{col.label}</h4>
                                                        {column === 'imported' ?
                                                            <div className='w-100'>
                                                                <input type="checkbox" className="btn-check" id={`input-lable${index}`} onChange={(event) => { qaStatus.toLowerCase() === 'rejected' && handleInputSelect(event, col.name) }} checked={rejectedListSupplierColumns.hasOwnProperty(col.name)} />
                                                                <label
                                                                    className={`d-flex  text-start rounded search-input p-4 align-items-center h4 mb-0  ${qaStatus.toLowerCase() === 'rejected' ? ' selectable' : ''} ${rejectedListSupplierColumns.hasOwnProperty(col.name) ? 'bg-sm-light-red text-red border-red' : ''}`}
                                                                    htmlFor={`input-lable${index}`}
                                                                >
                                                                    <div className='w-75 '>
                                                                        {currentSupplier?.[col.name]}
                                                                        {rejectedListSupplierColumns.hasOwnProperty(col.name) && (
                                                                            <div className='d-flex ms-auto align-items-center'>
                                                                                <BiError className='ms-auto fw-normal' color='#FF0000' size={24} />
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {
                                                                        currentSupplier?.[col.name] === null ? null : (
                                                                            <div className='w-25 d-flex justify-content-end'>
                                                                                <CopyToClipboard text={currentSupplier?.[col.name]}>
                                                                                    <button ><RiFileCopyLine size={26} color="rgb(87 171 234)" /></button>
                                                                                </CopyToClipboard>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </label>
                                                            </div>
                                                            :
                                                            <label
                                                                className={`d-flex  text-start rounded search-input p-4 align-items-center h4 mb-0 ${column === 'matched' ? ((unmatchedColumns.length && unmatchedColumns.includes(col.name) || !matchedSupplier)) ? 'bg-light-red' : 'bg-light-green' : ''} }`}
                                                                htmlFor={`input-lable${index}`}
                                                            >
                                                                {(page === "list" || page === 'partnerSubmission' || (page === "autoMatchedChildren" && col.name !== "suppliername")) && <div className={`w-75 search-input w-75 mb-0  border-0 ${column === 'matched' ? ((unmatchedColumns.length && unmatchedColumns.includes(col.name) || !matchedSupplier)) ? 'bg-light-red' : 'bg-light-green' : ''}`} >
                                                                    <input
                                                                        className={` search-input p-0 w-100 h-75 mb-0 border border-0 ${column === 'matched' ? ((unmatchedColumns.length && unmatchedColumns.includes(col.name) || !matchedSupplier)) ? 'bg-light-red' : 'bg-light-green' : ''}`}
                                                                        readOnly={true}
                                                                        value={
                                                                            column === 'matched'
                                                                                ?
                                                                                (matchedSupplier?.[col.name] || '') : (currentSupplier?.[col.name] || '')
                                                                        }
                                                                    />
                                                                </div>}

                                                                {
                                                                    (page === "autoMatchedChildren" && col.name === 'suppliername') && <div className={`w-75 search-input w-75 mb-0  border-0 ${column === 'matched' ? ((unmatchedColumns.length && unmatchedColumns.includes(col.name) || !matchedSupplier)) ? 'bg-light-red' : 'bg-light-green' : ''}`} >
                                                                        <Link to={`/suppliers/${matchedSupplier?.id}`} target="_blank">{matchedSupplier?.[col.name]}</Link>
                                                                    </div>
                                                                }

                                                                {
                                                                    currentSupplier?.[col.name] === null ? null : (
                                                                        <div className='w-25 d-flex justify-content-end w-25'>
                                                                            <CopyToClipboard text={column === 'matched' ?
                                                                                (matchedSupplier?.[col.name] || '') : (currentSupplier?.[col.name] || '')}>
                                                                                <button ><RiFileCopyLine size={26} color="rgb(87 171 234)" /></button>
                                                                            </CopyToClipboard>
                                                                        </div>
                                                                    )
                                                                }

                                                            </label>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className='me-5'>
                    <div className='ms-auto'>
                        {qaStatus.toLowerCase() === 'rejected' ?
                            (
                                <div>
                                    <button className='bg-secondary h4 mb-0 rounded text-white p-5 pt-3 pb-3 mx-2' onClick={handleGoBackClick}> Cancel </button>
                                    <button className='bg-green h4 mb-0 rounded text-white p-5 pt-3 pb-3' onClick={() => { handleApproveClick('reject') }}> Confirm </button>
                                </div>
                            )
                            :
                            <>
                                <button className='bg-green h4 mb-0 rounded text-white p-5 pt-3 pb-3' onClick={(e) => { onApproveClick() }}> Approve </button>
                                <button className='bg-red h4 mb-0 rounded text-white ms-4 p-5 pt-3 pb-3' onClick={() => { onRejectClick() }}> Reject </button>
                            </>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default QAList